import request from '@/utils/request.js'
import { addQueryToUrl } from '@/utils/utils'
import { workbenchServiceDict } from '@/dictionary/system'

const purchaseApi = process.env.VUE_APP_PURCHASE_API

// 分页查询代理服务费收取
export function getAgencyServiceFeeChargePageApi(params) {
  return request({
    url: purchaseApi + '/workbench/purchaser/bidding-service-fee/page',
    method: 'get',
    params
  })
}

// 代理服务费选择项目分页查询
export function getAgencyServiceFeeProjectPageApi(params) {
  return request({
    url: purchaseApi + '/workbench/purchaser/bidding-service-fee/project/page',
    method: 'get',
    params
  })
}

// 添加代理服务费（保存接口）
export function saveAgencyServiceFeeChargeApi(data) {
  return request({
    url: purchaseApi + '/workbench/purchaser/bidding-service-fee',
    method: 'post',
    data
  })
}

// 更新代理服务费
export function updateAgencyServiceFeeChargeSaveApi(data) {
  const { agentFeeId } = data
  return request({
    url: purchaseApi + `/workbench/purchaser/bidding-service-fee/${agentFeeId}`,
    method: 'put',
    data
  })
}

// 发布代理服务费项目
export function publishAgencyServiceFeeChargeApi(data) {
  return request({
    url: purchaseApi + '/workbench/purchaser/bidding-service-fee/publish',
    method: 'post',
    data
  })
}

// 更新并发布代理服务费
export function updateAgencyServiceFeeChargeApi(data) {
  const { agentFeeId } = data
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/bidding-service-fee/${agentFeeId}/publish`,
    method: 'put',
    data
  })
}

// 查询代理服务费项目详情
export function getAgencyServiceFeeChargeApi(params) {
  const { agentFeeId } = params
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/bidding-service-fee/${agentFeeId}/detail`,
    method: 'get'
  })
}

// 删除服务费收取
export function removeAgencyServiceFeeChargeApi(params) {
  return request({
    url: purchaseApi + '/workbench/purchaser/bidding-service-fee',
    method: 'delete',
    params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 作废代理服务费
export function invalidAgencyServiceFeeChargeApi(agentFeeId) {
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/bidding-service-fee/${agentFeeId}/invalid`,
    method: 'put',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 代理服务费收入管理分页查询
export function getAgencyServiceFeeIncomePageApi(params) {
  return request({
    url: purchaseApi + '/workbench/purchaser/bidding-service-fee/income/page',
    method: 'get',
    params
  })
}

// 查询收入详情
export function getAgencyServiceFeeIncomeInfoApi({ incomeId }) {
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/bidding-service-fee/income/${incomeId}/detail`,
    method: 'get'
  })
}

// 代理服务费收入处理接口
export function updateAgencyServiceFeeIncomeApi(data) {
  const { incomeId } = data
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/bidding-service-fee/deposit/${incomeId}/handle`,
    method: 'put',
    data
  })
}

// 代理服务费收入导出
export function exportAgencyServiceFeeIncomeApi(params) {
  window.open(
    addQueryToUrl(
      `${purchaseApi}/workbench/purchaser/bidding-service-fee/income/export`,
      { ...params, identity: workbenchServiceDict.AGENCY.alias }
    )
  )
}

// 添加、修改实际收入
export function changeAgencyServiceFeeActualIncomeApi(data) {
  const { agentFeeId } = data
  return request({
    url:
      purchaseApi +
      `/workbench/purchaser/bidding-service-fee/income/${agentFeeId}`,
    method: 'put',
    data
  })
}

// （财务）查询代理服务费详情
export function getAgencyServiceFeeInFinanceApi(params) {
  return request({
    url:
      purchaseApi + '/workbench/purchaser/bidding-service-fee/deposit/detail',
    method: 'get',
    params
  })
}

// 查询最新代理服务费收入开票表最新的项目
export function getLatestIncomeApi(params) {
  return request({
    url:
      purchaseApi + '/workbench/purchaser/bidding-service-fee/income/latestOne',
    method: 'get',
    params
  })
}
